import { createPageSlice } from "./createPageSlice";

// Server-paginated slice for the "InOpTra's Team Members - Client Mappings" Master Data grid.
const memberPageSlice = createPageSlice("memberPage", {
    defaultSortBy: "name",
    defaultSortDirection: "ASC",
});

export const memberPageActions = memberPageSlice.actions;
export default memberPageSlice;
